import React from "react";
import classes from "./DetailsCard.module.scss";

const DetailsCard = ({ title, summary, action, children }) => (
  <div className={classes.DetailsCard}>
    <div className={classes.CardHeader}>
      <div>
        <span className={classes.Title}>{title}</span>
        {summary && <span className={classes.Summary}>{summary}</span>}
      </div>

      {action}
    </div>

    {children}
  </div>
);

export default DetailsCard;
